import {useContext, useEffect, useState} from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import {FormControlLabel, Checkbox, Grid, Typography, SxProps} from '@mui/material';

import {EmpionPaper} from '../../../../../../../components/EmpionPaper/EmpionPaper';
import {LanguageContext} from '../../../../../../../contexts/LanguageContext/LanguageContext';
import {greenColors} from '../../../../../../../layouts/theme/designSystem';
import {Benefit} from '../../../types/SurveyQuestionnaireTypes';

interface BenefitsQuestionsProps {
  benefits: Benefit[] | undefined;
  handleChange: any;
  clearCheckboxes: boolean;
}

export default function BenefitsQuestions({benefits, handleChange, clearCheckboxes}: BenefitsQuestionsProps) {
  const currentLanguage = useContext(LanguageContext);
  const [checkedItems, setCheckedItems] = useState<string[]>([]);

  useEffect(() => {
    if (clearCheckboxes) {
      setCheckedItems([]);
    }
  }, [clearCheckboxes]);

  const paperStyle: SxProps = {
    backgroundColor: 'white',
    borderRadius: '16px',
    height: 'auto',
    maxWidth: {xs: '330px', sm: '100%', md: '736px'},
    minWidth: {xs: '330px', sm: '100%', md: '736px'},
    padding: {xs: '14px', sm: '18px', md: '28px'},
    marginTop: 1,
  };

  return (
    <EmpionPaper sx={paperStyle}>
      <Grid container>
        {benefits?.map((benefit: Benefit, index: number) => (
          <Grid item xs={12} sm={6} key={index}>
            <FormControlLabel
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
              }}
              name={benefit.label?.[currentLanguage]}
              control={
                <Checkbox
                  sx={{
                    padding: '3px 6px 0px 0px',
                    mb: '10px',
                  }}
                  onChange={(event) => {
                    handleChange(event);
                    if (event.target.checked) {
                      setCheckedItems([...checkedItems, event.target.value]);
                    } else {
                      setCheckedItems(checkedItems.filter((item) => item !== event.target.value));
                    }
                  }}
                  value={benefit.resourceId}
                  icon={
                    <RadioButtonUncheckedIcon
                      sx={{
                        color: greenColors[500],
                      }}
                    />
                  }
                  checkedIcon={
                    <CheckCircleIcon
                      sx={{
                        color: greenColors[500],
                      }}
                    />
                  }
                  checked={checkedItems.includes(benefit.resourceId)}
                />
              }
              label={
                <Typography
                  variant='h4'
                  sx={{
                    color: greenColors[500],
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {benefit.label?.[currentLanguage]}
                </Typography>
              }
            />
          </Grid>
        ))}
      </Grid>
    </EmpionPaper>
  );
}
